module.exports = __webpack_public_path__ + "static/media/image 18.dc0e489f.png";